import { createSnapshotPageSource } from "../../../shared/api/snapshot-page";
import { includesSearch } from "../../../shared/api/client-search-page";
import { readChatHistory } from "../infrastructure/read-chat-history";
import { conversationColumns } from "./conversation-table";

export function createConversationRecordsSource(token, chatId) {
  return createSnapshotPageSource({
    load: async (config) => ({ data: await readChatHistory(process.env.REACT_APP_API_CHAT_URL,
      token, chatId, config.cancelToken) }),
    matches: (row, term) => includesSearch([row.message, row.fileName, row.id, row.userId], term),
    header: conversationColumns,
  });
}
